import {withRouter, Link} from 'react-router-dom'
import Cookie from 'js-cookie'
import Popup from 'reactjs-popup'
import {IoMoon, IoSunnyOutline} from 'react-icons/io5'
import {
  ConfirmBtn,
  CancelBtn,
  LogoutWarning,
  PopupContentContainer,
  LogoutBtn,
  ProfileImg,
  ThemeProfileContainer,
  LogoImg,
  NavContainer,
  ThemeBtn,
} from './styledComponents'

import NxtWatchContext from '../../NxtWatchContext/NxtWatchContext'

const Header = props => {
  const onLogout = () => {
    const {history} = props
    Cookie.remove('jwt_token')
    history.replace('/login')
  }

  return (
    <NxtWatchContext.Consumer>
      {value => {
        const {darkMode, toggleTheme} = value
        const changeThemeIcon = darkMode ? <IoSunnyOutline /> : <IoMoon />
        const logoUrl = darkMode
          ? 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-dark-theme-img.png'
          : 'https://assets.ccbp.in/frontend/react-js/nxt-watch-logo-light-theme-img.png'

        return (
          <NavContainer darkMode={darkMode}>
            <Link to="/">
              <LogoImg src={logoUrl} alt="website logo" />
            </Link>
            <ThemeProfileContainer>
              <ThemeBtn
                darkMode={darkMode}
                onClick={toggleTheme}
                data-testid="theme"
                type="button"
              >
                {changeThemeIcon}
              </ThemeBtn>
              <ProfileImg
                src="https://assets.ccbp.in/frontend/react-js/nxt-watch-profile-img.png"
                alt="profile"
              />
              <Popup
                modal
                trigger={<LogoutBtn type="button">Logout</LogoutBtn>}
                className="popup-content"
              >
                {close => (
                  <PopupContentContainer darkMode={darkMode}>
                    <LogoutWarning darkMode={darkMode}>
                      Are you sure, you want to logout
                    </LogoutWarning>
                    <CancelBtn type="button" onClick={close}>
                      Cancel
                    </CancelBtn>
                    <ConfirmBtn type="button" onClick={onLogout}>
                      Confirm
                    </ConfirmBtn>
                  </PopupContentContainer>
                )}
              </Popup>
            </ThemeProfileContainer>
          </NavContainer>
        )
      }}
    </NxtWatchContext.Consumer>
  )
}
export default withRouter(Header)
